<template>
    <div>
      <div class="common-header-wrap">
        <mt-header title="استقر المتجر" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
        <step :options="options" :active="1"></step>

        <div v-if="storeJoinin.store_type==0">
            <div>
                <div class="label">بنك المعلومات</div>
                <mt-field label="اسم البنك" v-model="storeJoinin.bank_account_name"></mt-field>
                <mt-field label="حساب الشركة" v-model="storeJoinin.bank_account_number"></mt-field>
                <mt-field label="اسم فرع البنك" v-model="storeJoinin.bank_name"></mt-field>
                <div @click="onRegion('bank_address')"><mt-cell title="مكان البنك" is-link>{{storeJoinin.bank_address}}</mt-cell></div>
                <mt-cell title="هذا الحساب حساب تسوية">
                    <mt-switch v-model="isSame"></mt-switch>
                </mt-cell>
            </div>
            <div v-if="!isSame">
                <div class="label">معلومات حساب التسوية</div>
                <mt-field label="اسم البنك" v-model="storeJoinin.settlement_bank_account_name"></mt-field>
                <mt-field label="حساب الشركة" v-model="storeJoinin.settlement_bank_account_number"></mt-field>
                <mt-field label="اسم فرع البنك" v-model="storeJoinin.settlement_bank_name"></mt-field>
                <div @click="onRegion('settlement_bank_address')"><mt-cell title="موقع البنك" is-link>{{storeJoinin.settlement_bank_address}}</mt-cell></div>
            </div>
        </div>
        <div v-else>
            <mt-field label="اسم Alipay" v-model="storeJoinin.settlement_bank_account_name"></mt-field>
            <mt-field label="حساب Alipay" v-model="storeJoinin.settlement_bank_account_number"></mt-field>
        </div>
        <mt-button size="large" type="primary" @click="nextStep" class="ds-button-large mt-10">الخطوة التالية</mt-button>
        <div>
            <region-picker ref="picker" @onConfirm="onPickerConfirm"></region-picker>
        </div>
    </div>
</template>
<script>

import { Toast, MessageBox } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import RegionPicker from '../../RegionPicker'
import Step from '../../Step'
import { getStoreJoinin, saveStoreJoinin3 } from '../../../api/seller'
export default {
  components: {
    Step,
    RegionPicker
  },
  data () {
    return {
      isSame: false,
      regionName: '',
      options: [{ title: 'تأهيل الشركة' }, { title: 'المؤهل المالي' }, { title: 'معلومات المتجر' }, { title: 'توقيع عقد' }]
    }
  },
  mounted () {
  },
  computed: {
    ...mapState({
      storeJoinin: state => state.member.storeJoinin,
      config: state => state.config.config
    })
  },
  created: function () {
    this.isSame = !!this.storeJoinin.is_settlement_account
    getStoreJoinin().then(res => {
      var store_joinin = res.result.store_joinin
      if (store_joinin) {
        if (store_joinin.joinin_state == 11 || store_joinin.joinin_state == 20 || store_joinin.joinin_state == 31) {
          this.$router.push({ name: 'SellerJoinin5' })
          return
        }
        if (store_joinin.joinin_state == 40) {
            Toast('تم فتح متجرك')
          this.$router.push({ name: 'HomeSellerLogin' })
          return
        }
        // if (!this.storeJoinin) {
          this.isSame = !!this.storeJoinin.is_settlement_account
          this.sellerJoininSave({ storeJoinin: store_joinin })
          this.fetchConfig({}).then(
            response => {
              if(this.config.store_joinin_open==2 || this.config.store_joinin_open==3){
                if(this.config.store_joinin_open==3){
                  this.storeJoinin['store_type']=1
                }
                if(this.config.store_joinin_open==2){
                  this.storeJoinin['store_type']=0
                }
                this.$forceUpdate()
              }
            },
            error => {
              Toast(error.message)
            }
          )
        // }
      }
    }).catch(error => {
      Toast(error.message)
    })
  },

  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig',
    }),
    ...mapMutations({
      memberPoint: 'memberPoint',
      sellerJoininSave: 'sellerJoininSave'
    }),
    nextStep () {
      this.storeJoinin.is_settlement_account = this.isSame
      saveStoreJoinin3(this.storeJoinin).then(res => {
        this.sellerJoininSave({ storeJoinin: this.storeJoinin })
        this.$router.push({ name: 'SellerJoinin4' })
      }).catch(error => {
        Toast(error.message)
      })
    },
    onPickerConfirm (values) {
      if (this.regionName == 'bank_address') {
        this.storeJoinin.bank_address = this.getRegionStr(values)
      }
      if (this.regionName == 'settlement_bank_address') {
        this.storeJoinin.settlement_bank_address = this.getRegionStr(values)
      }
      this.$forceUpdate()
    },
    onRegion (name) {
      this.regionName = name
      this.$refs.picker.currentValue = true
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    }
  }
}
</script>
<style  lang="scss" scoped>
    .container {
        background: #fff;
    }
    .label {
        padding: .5rem;
        font-size: .7rem;
        background: #eee;
    }
</style>
